import React from "react";
import { useTheme } from "@mui/material/styles";

const StatusNotStartedIcon = () => {
  const theme = useTheme();
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.56 9C16.56 4.824 13.175 1.44 9 1.44C4.824 1.44 1.44 4.824 1.44 9C1.44 13.175 4.824 16.56 9 16.56V18C4.03 18 0 13.97 0 9C0 4.03 4.03 0 9 0C13.97 0 18 4.03 18 9C18 13.97 13.97 18 9 18V16.56C13.175 16.56 16.56 13.175 16.56 9Z" fill={theme.palette.grey[300]}/>
      <circle cx="9" cy="9" r="3.6" fill={theme.palette.grey[300]}/>
    </svg>
  );
};

export default StatusNotStartedIcon;
